/** @format */

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import buttonStyle from '../../assets/jss/adescom/buttonTemplateStyle';
import { Tooltip } from '@material-ui/core';

import I18n from '../../components/Translate/I18n';
import OplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

function TemplateButton({ ...props }) {
    const {
        classes,
        color,
        round,
        fullWidth,
        disabled,
        simple,
        size,
        block,
        link,
        justIcon,
        className,
        muiClasses,
        icon,
        callback,
        callbackParam,
        text,
        tooltipTitle,
        tooltipPlacement,
        translationObject,
        nonTableButton,
        ...rest
    } = props;
    const btnClasses = classNames({
        [classes.button]: true,
        [classes[size]]: size,
        [classes[color]]: color,
        [classes.round]: round,
        [classes.fullWidth]: fullWidth,
        [classes.buttonDisabled]: disabled,
        [classes.simple]: simple,
        [classes.block]: block,
        [classes.link]: link,
        [classes.justIcon]: justIcon,
        [classes.tableButton]: !nonTableButton,
        [className]: classes.actionButton,
    });
    if (tooltipTitle) {
        return (
            <Tooltip
                title={<I18n trans={tooltipTitle} valueObject={translationObject} />}
                id="tooltip-top"
                placement={tooltipPlacement}
                classes={{ tooltip: classes.tooltip }}
            >
                <Button
                    {...rest}
                    size="small"
                    classes={muiClasses}
                    className={btnClasses}
                    onMouseUp={(event) => {
                        callback(callbackParam, event);
                    }}
                >
                    {props.icon && <props.icon className={classes.icon} />}
                    {text}
                </Button>
            </Tooltip>
        );
    }
    return (
        <Button
            {...rest}
            size="small"
            classes={muiClasses}
            className={btnClasses}
            onMouseUp={(event) => {
                callback(callbackParam, event);
            }}
        >
            {props.icon && <props.icon className={classes.icon} />}
            {text}
        </Button>
    );
}

TemplateButton.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        'primary',
        'info',
        'success',
        'warning',
        'danger',
        'rose',
        'white',
        'twitter',
        'facebook',
        'google',
        'linkedin',
        'pinterest',
        'youtube',
        'tumblr',
        'github',
        'behance',
        'dribbble',
        'reddit',
        'transparent',
    ]),
    size: PropTypes.oneOf(['sm', 'lg']),
    simple: PropTypes.bool,
    round: PropTypes.bool,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    block: PropTypes.bool,
    link: PropTypes.bool,
    justIcon: PropTypes.bool,
    className: PropTypes.string,
    muiClasses: PropTypes.object,
    callback: PropTypes.func,
    callbackParam: PropTypes.object,
    text: PropTypes.string,
    tooltipTitle: PropTypes.string,
    tooltipPlacement: PropTypes.string,
};

export default withStyles(OplAppStyle)(TemplateButton);
